export default "/images/b4d177b8bb19a5bf85ee0b10c63c385a.avif";